import Repository from "../Repository";

const create = "create";
const get = "get";
const deleteCategory = "delete";
const update = "update";

export default {
  create(payload) {
    return Repository.post(transformRoute(create), payload);
  },

  get(payload) {
    return Repository.post(transformRoute(get), payload);
  },

  update(payload) {
    return Repository.post(transformRoute(update), payload);
  },

  delete(payload) {
    return Repository.post(transformRoute(deleteCategory), payload);
  },
};

const transformRoute = (route) => {
  return `/blogs/category/${route}`;
};
